import { render, staticRenderFns } from "./temperature-histogram.vue?vue&type=template&id=d7dd9d9a"
import script from "./temperature-histogram.vue?vue&type=script&lang=js"
export * from "./temperature-histogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports